import ApiService from '@/services/apiService';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
import { mapState } from 'vuex';
export default {
  name: 'ViewISAssetMgmtMap',
  mixins: [MapViewMixin],
  data: function () {
    return {
      selectedAccounts: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    requestFilter() {
      if (this.selectedAccounts.length === 0) {
        return [];
      }
      return [{
        type: 'tenantIds',
        ids: this.selectedAccounts
      }];
    }
  },
  watch: {
    selectedAccounts() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    }
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    fetchTwinData() {
      this.loadTree();
      return ApiService.isAssetMgmtFetchGeoMetaInfos(this, this.requestFilter).then(data => {
        this.stateKeys = data.keyList;
        this.twinTags = data.tagList;
        this.floorList = data.floorList;
      }).catch(error => {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    resetDefaults() {
      this.selectedStateKey = null;
      this.selectedTwinTag = null;
      this.gradientPolygonColours = false;
      this.selectedAccounts = [];
    },
    getClusterContent(cluster, bounds) {
      if (!cluster) {
        this.selectedCluster = {};
        return;
      }
      ApiService.isAssetMgmtGetGeoClusterContent(this, cluster.id, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], null,
      // search-item
      this.selectedTwinTag, this.requestFilter,
      // filters
      [] // options
      ).then(data => {
        this.selectedCluster = {
          ...cluster,
          items: data.dtwins
        };
      }).catch(error => {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree(bounds = undefined) {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      return ApiService.isAssetMgmtFetchGeoClusters(this, this.indoorFloorDtwinId, bounds, null,
      // search-item
      this.selectedTwinTag, this.requestFilter,
      // filters
      [],
      // options
      this.selectedStateKey).then(data => {
        this.calculateBoundingBox(data);
        this.markerItems = data.dtwins;
      }).catch(error => {
        console.error('Error loading map-twin-clusters', error);
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};